var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5819 21.1114C39.5918 20.895 39.5578 20.6789 39.4822 20.4771C39.4066 20.2753 39.2911 20.0922 39.1431 19.9397C38.9951 19.7872 38.818 19.6687 38.6231 19.5919C38.4283 19.5151 38.2201 19.4816 38.012 19.4937C37.8062 19.4756 37.599 19.503 37.4041 19.5739C37.2091 19.6448 37.0308 19.7576 36.8807 19.9051C36.7306 20.0526 36.6122 20.2313 36.5332 20.4296C36.4541 20.6279 36.4163 20.8414 36.4221 21.0559C36.427 21.3077 36.5008 21.5527 36.6347 21.7626C36.7686 21.9724 36.9571 22.1384 37.1784 22.2411L35.5938 22.6098V23.5885C36.4447 23.3833 38.0867 23.0243 37.9947 23.0437C38.4438 22.9861 38.8558 22.7558 39.1496 22.3981C39.4435 22.0404 39.5977 21.5814 39.5819 21.1114ZM37.5038 21.0005C37.5012 20.9283 37.5129 20.8564 37.5383 20.7892C37.5636 20.7219 37.602 20.6608 37.6511 20.6097C37.7001 20.5586 37.7588 20.5185 37.8234 20.492C37.8881 20.4655 37.9572 20.4532 38.0267 20.4557C38.1668 20.4714 38.2957 20.5425 38.3868 20.6542C38.4779 20.7659 38.5242 20.9097 38.5162 21.0559C38.545 21.352 38.4666 21.6485 38.2961 21.8876C38.1866 21.8878 38.0781 21.8647 37.9774 21.8199C37.8767 21.7751 37.7859 21.7095 37.7104 21.627C37.6349 21.5445 37.5763 21.4469 37.5383 21.3402C37.5002 21.2334 37.4835 21.1197 37.4891 21.006L37.5038 21.0005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5831 24.9799C36.5303 24.9981 35.4846 25.1627 34.4738 25.4692V31.1152C34.4738 32.2242 33.9176 32.5222 32.8224 32.5222C31.682 32.5222 31.1431 32.2214 31.1431 31.136V20.7188H29.217V31.1388C29.217 32.2283 28.6581 32.525 27.5523 32.525C26.4225 32.525 25.8849 32.2214 25.8849 31.1388V28.0975C25.9135 27.6707 25.8518 27.2426 25.7041 26.8432C25.5564 26.4438 25.3264 26.0829 25.0302 25.7858C24.734 25.4887 24.3788 25.2626 23.9896 25.1234C23.6003 24.9841 23.1864 24.9352 22.777 24.9799C22.3677 24.9354 21.954 24.9845 21.565 25.1238C21.176 25.2631 20.821 25.4893 20.525 25.7864C20.2291 26.0835 19.9993 26.4444 19.8519 26.8437C19.7045 27.2429 19.643 27.6709 19.6717 28.0975V29.7512C19.6548 30.77 19.8759 31.7779 20.316 32.6885C19.7101 32.852 19.1784 33.2306 18.8129 33.7587C18.4475 34.2869 18.2714 34.9312 18.3152 35.5801C18.4364 36.9275 18.754 38.2479 19.2569 39.4961L21.0656 38.821C20.6636 37.7732 20.3903 36.6768 20.2519 35.5579C20.2519 34.6015 20.5654 34.2522 21.4418 34.2522H22.7757C23.2085 34.2754 23.6412 34.204 24.0458 34.0425C24.4504 33.8811 24.8179 33.6333 25.1246 33.3151C25.7555 33.9094 26.5754 34.2406 27.4269 34.2452C27.4423 34.2488 27.4582 34.2488 27.4736 34.2452H27.6897C28.6136 34.2635 29.5109 33.9235 30.2067 33.2915C30.9011 33.9071 31.7843 34.2449 32.6971 34.2438H32.9545C33.8067 34.2371 34.6348 33.9492 35.3195 33.4218C35.6029 33.7543 35.9555 34.0152 36.3505 34.1848C36.7455 34.3543 37.1725 34.4281 37.5991 34.4005C38.0085 34.4465 38.4227 34.3984 38.8123 34.2597C39.2018 34.121 39.5573 33.895 39.8536 33.5977C40.1498 33.3005 40.3796 32.9391 40.5266 32.5394C40.6736 32.1396 40.7343 31.7112 40.7043 31.2843V28.0933C40.7293 27.6664 40.6646 27.2389 40.5148 26.8406C40.3649 26.4422 40.1336 26.0825 39.8366 25.7864C39.5397 25.4902 39.1844 25.2647 38.7952 25.1254C38.4061 24.9862 37.9925 24.9365 37.5831 24.9799ZM23.9615 31.1152C23.9615 32.1465 23.6 32.5222 22.7676 32.5222H22.2434C21.6977 31.6921 21.4607 30.6842 21.5765 29.686V28.1363C21.5765 27.1022 21.922 26.7265 22.7703 26.7265C23.6187 26.7265 23.9641 27.1022 23.9641 28.1363L23.9615 31.1152ZM38.7676 31.2815C38.7676 32.3156 38.4247 32.6913 37.5777 32.6913C36.7307 32.6913 36.3772 32.3156 36.3772 31.2815V26.8457C36.7715 26.7554 37.174 26.709 37.5777 26.7071C38.4261 26.7071 38.7676 27.0828 38.7676 28.1169V31.2815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4961 5.89964L58.9976 23.5999L49.1629 5.89964L39.3308 0L29.4961 5.89964Z",
    fill: "url(#paint0_linear_1176_1664)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 0L9.83203 5.89964V17.6989L19.6668 11.7993L29.4988 5.89964L39.3336 0H19.6668Z",
    fill: "url(#paint1_linear_1176_1664)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.6026V35.4019L9.83194 41.3016V5.90234L0 23.6026Z",
    fill: "url(#paint2_linear_1176_1664)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83203 53.0987L19.6667 58.9984L29.4988 53.0987L19.6667 47.1977L0 35.3984L9.83203 53.0987Z",
    fill: "url(#paint3_linear_1176_1664)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 53.0962L19.668 58.9972H39.3347L49.1667 53.0975V41.2969L29.5 53.0962Z",
    fill: "url(#paint4_linear_1176_1664)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1602 53.0984L58.9947 35.3995V23.5989L49.1602 17.6992V53.0984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1176_1664",
    x1: 29.4961,
    y1: 0,
    x2: 53.9899,
    y2: 26.1171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766366,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1176_1664",
    x1: 9.83203,
    y1: 14.8494,
    x2: 20.0566,
    y2: -5.37547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1176_1664",
    x1: 4.91597,
    y1: 46.6114,
    x2: 4.91597,
    y2: 23.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F5F0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1176_1664",
    x1: 32.8911,
    y1: 63.5768,
    x2: 10.3913,
    y2: 35.7415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76895,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1176_1664",
    x1: 57.2199,
    y1: 41.7748,
    x2: 45.1523,
    y2: 62.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494275,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo6.4cc8784457fb7217d97c1abe8a5124a1.svg";
export { ForwardRef as ReactComponent };